// src/routes/Login/index.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { setAuth } from "../../features/auth/authSlice";
import "./index.css";
import logo from "../../assets/originelogo.png";

export default function Login() {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  async function submit() {
    try {
      const cred = await signInWithEmailAndPassword(auth, email, pass);

      // ВАЖНО: force refresh, чтобы новые custom claims попали в токен
      const token = await cred.user.getIdToken(true);
      const tokenRes = await cred.user.getIdTokenResult();
      const role = (tokenRes.claims.role as "admin" | "client") || "client";

      dispatch(setAuth({ token, role }));

      // Редирект по роли
      nav(role === "admin" ? "/admin" : "/profile", { replace: true });
    } catch (e: any) {
      setError(e.message || "Ошибка авторизации");
    }
  }

  return (
    <div className="login">
      <div className="login__top">
        <img src={logo} className="login__logo" />
        <nav className="login__nav">
          <span>Главная</span>
          <span>Поддержка</span>
        </nav>
      </div>

      <div className="login__main">
        <h1 className="login__title">Создайте свою парфюмную коллекцию</h1>

        <div className="login__form">
          <input
            className="login__input"
            type="text"
            placeholder="Почта"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="off"
          />
          <input
            className="login__input"
            type="text"
            placeholder="Пароль"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            autoComplete="off"
          />
          <button className="login__button" onClick={submit}>
            Продолжить
          </button>
        </div>

        {error && <p className="login__error">{error}</p>}
        <p className="login__note">Нет аккаунта? Свяжитесь с менеджером.</p>
      </div>
    </div>
  );
}
